import React, { useState, useEffect } from "react";

const AmountApprove = ({ approveAmount, setApproveAmount, note, setNote, requestedAmount }) => {
  const [amountType, setAmountType] = useState("requested");
  const [customAmount, setCustomAmount] = useState("");

  // Update approveAmount in parent when local changes
  useEffect(() => {
    if (amountType === "requested") {
      setApproveAmount(requestedAmount);
    } else {
      setApproveAmount(customAmount);
    }
  }, [amountType, customAmount, requestedAmount, setApproveAmount]);

  return (
    <div className="bg-[#131313] rounded-lg p-4 flex-1">
      <h3 className="text-md font-medium text-white mb-3">Approve Amount</h3>

      {/* Amount Type Toggle */}
      <div className="flex items-center gap-6 mb-4 text-sm text-white">
  {[
    {
      label: `Requested Amount (₹${requestedAmount || 0})`,
      value: "requested",
    },
    {
      label: "Custom Amount",
      value: "custom",
    },
  ].map((option) => (
    <label key={option.value} className="flex items-center cursor-pointer">
      <input
        type="radio"
        name="amountType"
        checked={amountType === option.value}
        onChange={() => setAmountType(option.value)}
        className="hidden"
      />
      <span
        className={`w-5 h-5 rounded-full border-2 mr-2 flex items-center justify-center ${
          amountType === option.value
            ? "border-yellow-400"
            : "border-gray-400"
        }`}
      >
        {amountType === option.value && (
          <span className="w-2.5 h-2.5 bg-yellow-400 rounded-full" />
        )}
      </span>
      <span
        className={
          amountType === option.value ? "text-yellow-400" : "text-gray-300"
        }
      >
        {option.label}
      </span>
    </label>
  ))}
</div>


      {/* Custom Amount Input */}
      {amountType === "custom" && (
        <div className="relative mb-4">
          <span className="absolute left-3 top-2.5 text-gray-400">₹</span>
          <input
            type="number"
            value={customAmount}
            onChange={(e) => setCustomAmount(e.target.value)}
            placeholder="Enter custom amount"
            className="w-full pl-8 pr-4 py-2 bg-[#1e1e1e] border border-[#333333] text-white rounded-md placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-yellow-400"
          />
        </div>
      )}

      {/* Note Input */}
      <div className="mb-6">
        <label className="block text-sm text-gray-300 mb-1">Add Note</label>
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Enter a note"
          className="w-full px-3 py-2 bg-[#1e1e1e] border border-[#333333] text-white rounded-md placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-yellow-400 min-h-[80px]"
        />
      </div>
    </div>
  );
};

export default AmountApprove;
